import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import InvoiceTable from '../components/InvoiceTable';
import { Box, Stack } from '@mui/material';
import DocumentListFilters from '../../../components/filters/DocumentListFilters';
import useDocumentFilters from '../../../components/filters/DocumentFilterHelper';

const filters = [
  {
    type: 'search',
    options: [
      { key: 'document_number', placeholder: 'Invoice Number' },
      { key: 'billed_by_name', placeholder: 'Seller Name' },
      { key: 'billed_to_name', placeholder: 'Buyer Name' },
      { key: 'billed_to_phone', placeholder: 'Buyer Phone' },
      { key: 'billed_to_tin', placeholder: 'Buyer TIN' },
      { key: 'billed_to_registration_number', placeholder: 'Buyer Registration Number' },
    ],
  },
];

function InvoiceListPage() {
  useDocumentTitle('Invoice List');

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    includeResubmitted = false,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleStatusChange,
    handleDateRangeChange,
    handleIncludeResubmittedChange,
    handlePaginationChange,
  } = useDocumentFilters({ defaultQuery: { document_type: '01', status: new Set(['active']) } });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box mb={2}>
        <DocumentListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          onStatusChange={handleStatusChange}
          onDateRangeChange={handleDateRangeChange}
          includeResubmitted={includeResubmitted}
          onIncludeResubmittedChange={handleIncludeResubmittedChange}
        />
      </Box>
      <InvoiceTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default InvoiceListPage;
